import styles from './ImpressaoAutomatica.module.css';
import SideBarGestaoAdmin from '../components/SideBarGestaoAdmin';
import MobileMenu from '../../../shared/components/MobileMenu';
import HeaderAdmin from '../components/HeaderAdmin';
import PainelImpressao from '../../../shared/components/PainelImpressao';
import { MdPrint } from 'react-icons/md';

function ImpressaoAutomatica() {
  const estabelecimentoId = localStorage.getItem('estabelecimento_id');

  return (
    <div className={styles.wrapperDashboard}>
      <MobileMenu />
      <SideBarGestaoAdmin />
      <div className={styles.containerDashboard}>
        <HeaderAdmin />
        <div className={styles.contentDashboard}>
          <div className={styles.cabecalhoPagina}>
            <span className={styles.iconePagina}><MdPrint /></span>
            <div className={styles.cabecalhoPaginaTextos}>
              <h2 className={styles.tituloPagina}>Impressão automática</h2>
              <p className={styles.subtituloPagina}>Os pedidos confirmados saem sozinhos na impressora do restaurante, mesmo com este painel fechado.</p>
            </div>
          </div>

          <PainelImpressao idEstabelecimento={estabelecimentoId} />
        </div>
      </div>
    </div>
  );
}

export default ImpressaoAutomatica;
